import React from 'react';

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.00049" cy="7" r="6.25" stroke="white" strokeWidth="1.5" />
    <circle cx="7.00033" cy="7.00033" r="4.08333" fill="white" />
  </svg>
);
